import React from 'react';
import styled from 'styled-components';
import { useDebug } from '../utils/hooks/useDebug.js';
import { mergeMediaQueries, debugCss, calcSpacerMaxValues, calcSpacerMeasures, calcSpacerInline } from '../utils/styleHelpers.js';

const Spacer = ({
  isInline = false,
  isNotStretching = false,
  maxX,
  maxY,
  testId = 'Spacer',
  x,
  y
}) => {
  const className = useDebug();
  return React.createElement(SpacerElement, {
    $isInline: isInline,
    $isNotStretching: isNotStretching,
    $maxX: maxX,
    $maxY: maxY,
    $x: x,
    $y: y,
    "aria-hidden": "true",
    className: className,
    "data-cy": testId
  });
};
Spacer.displayName = 'Spacer';
var Spacer$1 = Spacer;
const SpacerElement = styled.span.withConfig({
  displayName: "Spacer__SpacerElement",
  componentId: "sc-1j7q185-0"
})(["flex:1 1 0rem;", ";", ""], mergeMediaQueries(calcSpacerInline, calcSpacerMeasures('height'), calcSpacerMeasures('min-height'), calcSpacerMeasures('width'), calcSpacerMeasures('min-width'), calcSpacerMaxValues('max-height'), calcSpacerMaxValues('max-width')), debugCss('spacer'));

export { Spacer$1 as default };
//# sourceMappingURL=Spacer.js.map
